<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <div class="form-group">
        <input name="name"
               type="text"
               class="form-control"
               :class="{'form-alert': errors.has('name')}"
               placeholder="ชื่อ-สกุล"
               v-model="userData.name"
               v-validate="'required'">
        <span v-show="errors.has('name')" class="help text-danger">{{ errors.first('name') }}</span>
      </div>
      <div class="form-group">
        <input name="tel"
               type="text"
               class="form-control"
               :class="{'form-alert': errors.has('name')}"
               placeholder="เบอร์โทร"
               v-model="userData.tel"
               v-validate="'required'">
        <span v-show="errors.has('tel')" class="help text-danger">{{ errors.first('tel') }}</span>
      </div>
      <div class="form-group">
        <input name="email"
               type="text"
               class="form-control"
               :class="{'form-alert': errors.has('name')}"
               placeholder="อีเมล"
               v-model="userData.email"
               v-validate="'required|email'">
        <span v-show="errors.has('email')" class="help text-danger">{{ errors.first('email') }}</span>
      </div>
      <div class="form-group" v-if="!saveSuccess">
        <button class="btn btn-block btn-info" :disabled="loading" @click="checkEmailAccount()">
          {{ isRegistering }}
        </button>
      </div>
      <div class="text-center mt-4" v-else>
        <h3>
          <i class="fas fa-check-circle -status-accepted"></i> ลงทะเบียนสำเร็จ
        </h3>
      </div>
      <!-- Received Coins from friend invitation -->
      <div class="text-center mt-4" v-if="receivedCredits">
        <hr>
        <div>
          <i class="fas fa-coins -icon-coins"></i> {{ $t('message.invite_friends.earned_coins_from_friend_invitation') }}
        </div>
        <div class="mt-2">
          <h3>{{ receivedCredits | currency }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { parse, format } from 'libphonenumber-js'
  import axios from 'axios'
  import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'
  import { firebaseAuth } from '../../../helpers/firebaseHelpers'
  import loginHelpers from '../../../helpers/loginHelpers'

  export default {
    props: {
      message: Object
    },
    data () {
      return {
        userData: {
          name: null,
          tel: null,
          email: null
        },
        nonce: null,
        loading: false,
        saveSuccess: false,
        receivedCredits: null
      }
    },
    computed: {
      isRegistering () {
        return (this.loading) ? 'กำลังลงทะเบียน...' : 'ยืนยัน'
      }
    },
    methods: {
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      checkEmailAccount () {
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            try {
              this.nonce = await loginHelpers.getNonce()
              if (this.nonce) {
                this.loading = true
                const url = 'auth/check-email-account'
                const submitData = {
                  email: this.userData.email,
                  nonce: this.nonce
                }
                const { data } = await axios.post(url, submitData)
                if (data) {
                  const user = data.user
                  if (user === null) {
                    this.createFirebaseUser()
                  } else {
                    this.saveSuccess = true
                    let text = ''
                    if (user) {
                      const parsedResult = parse(this.userData.tel, 'TH')
                      const phone = format(parsedResult.phone, parsedResult.country, 'International')
                      const formattedPhoneNumber = phone.replace(/ /g, '')
                      if (formattedPhoneNumber !== user.tel) {
                        text += 'เบอร์โทรที่ลงทะเบียนไว้ไม่ตรงกับที่กรอกมา'
                      }
                      text += ` ส่ง OTP ไปที่เบอร์โทรที่ลงทะเบียนไว้ (${user.tel})`
                    }
                    const action = {
                      label: 'otp',
                      text: `${this.userData.name}, ${this.userData.tel}, ${this.userData.email} ${text}`,
                      data: `user_id=${user.id}&email=${this.userData.email}`
                    }
                    this.sendMessage(action)
                  }
                }
              }
            } catch (error) {
              let alertMessage = error.message
              if (error.response && error.response.data && error.response.data.message) {
                alertMessage = error.response.data.message
              }
              this.showAlertMessage(alertMessage)
              // console.log('check error', error)
            }
          }
        })
      },
      createFirebaseUser () {
        const email = this.userData.email
        const password = this.userData.tel
        const name = this.userData.name
        createUserWithEmailAndPassword(firebaseAuth, email, password)
          .then((userCredential) => {
            updateProfile(userCredential.user, {
              displayName: name
            }).then(() => {
              this.registerUser()
            }).catch((error) => {
              this.showAlertMessage(error.message)
            })
          })
          .catch(error => {
            console.log('error register', error)
            if (error.code) {
              this.showAlertMessage(this.$i18n.t('message.alert.email_is_registered'))
            }
          })
      },
      registerUser () {
        console.log('registerUser')
        let firstname = this.userData.name
        let lastname = ''
        const arrName = this.userData.name.split(' ')
        if (arrName.length > 1) {
          firstname = arrName[0]
          lastname = arrName[1]
        }
        const submitData = {
          email: this.userData.email,
          firstname: firstname,
          lastname: lastname,
          platform: 'chat',
          picture: 'https://beneat.co/static/img/unknown.png',
          social_name: 'email_password',
          tel: this.userData.tel
        }
        // Check user referral code (friend recommendation) to get 50 coins
        let queryParams = this.$route.query
        if (queryParams.c) {
          submitData.referral_code = queryParams.c
        }
        if (this.nonce) {
          submitData.nonce = this.nonce
        }
        const url = 'register'
        axios.post(url, submitData)
          .then(res => {
            const response = res.data
            const message = response.message
            if (!response.error) {
              this.loading = false
              this.saveSuccess = true
              this.receivedCredits = (response.credits) ? response.credits : null
              const user = response.user
              let text = (user) ? `ส่ง OTP ไปที่เบอร์โทรที่ลงทะเบียนไว้ (${user.tel})` : ''
              const action = {
                label: 'otp',
                text: `${this.userData.name}, ${this.userData.tel}, ${this.userData.email} ${text}`,
                data: `user_id=${user.id}&email=${this.userData.email}`
              }
              this.sendMessage(action)
            } else {
              this.showAlertMessage(message)
            }
          })
          .catch(error => {
            this.showAlertMessage(error.message)
            console.log(error)
          })
      },
      showAlertMessage (alertMessage) {
        this.loading = false
        this.$swal({
          text: alertMessage,
          type: 'error'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/RegisterMessage.vue